// utils/pageTracker.js

let lastPageUrl = typeof window !== "undefined" ? window.location.href : "";

export const setLastPageUrl = (url) => {
    lastPageUrl = url;
};

export const getLastPageUrl = () => {
    return lastPageUrl;
};